import { useEffect, useRef } from 'react';

// Focus remains inside our overlay, and returns to its opener on close.
export const useDialogFocus = (onClose, active = true, returnFocusRef) => {
    const ref = useRef(null);
    const closeRef = useRef(onClose);
    closeRef.current = onClose;
    useEffect(() => {
        if (!active || !ref.current) return undefined;
        const previous = returnFocusRef?.current || document.activeElement;
        const dialog = ref.current;
        const focusable = () => [...dialog.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),a[href]')];
        focusable()[0]?.focus();
        const handleKey = (event) => {
            if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeRef.current?.(); }
            if (event.key !== 'Tab') return;
            const nodes = focusable(); const first = nodes[0]; const last = nodes[nodes.length - 1];
            if (!first) { event.preventDefault(); return; }
            if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        };
        dialog.addEventListener('keydown', handleKey);
        return () => { dialog.removeEventListener('keydown', handleKey); if (previous?.isConnected) previous.focus(); };
    }, [active, returnFocusRef]);
    return ref;
};
